(function () {
  // Liquid から渡る文言・顧客IDは JSON 設定ブロックから取得（JS本体を静的化＝CDNキャッシュ対象にするため）
  var cfgEl = document.getElementById('article-comments-config');
  var cfg = {};
  if (cfgEl) {
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      cfg = {};
    }
  }

  var list = document.querySelector('.article-comments-list');
  if (list) {
    var comments = Array.prototype.slice.call(
      list.querySelectorAll('.article-template__comments-comment')
    );
    var map = {};
    comments.forEach(function (art) {
      if (art.dataset.commentId) map[art.dataset.commentId] = art;
    });
    // 返信先（data-parent-id）はサーバー側（Liquid）で付与済み
    // 返信先チェーンを辿ってトップコメント（最上位の親）を取得
    function rootOf(art) {
      var cur = art;
      var guard = 0;
      while (cur && cur.dataset.parentId && map[cur.dataset.parentId] && guard < 100) {
        cur = map[cur.dataset.parentId];
        guard++;
      }
      return cur;
    }
    // 投稿者名（投稿者ID部分を除いた表示名）を取得
    function authorName(art) {
      var el = art.querySelector('.comment-author-name');
      return el ? el.textContent.trim() : '';
    }
    // YouTube式：返信は深さに関係なくトップコメント直下の1階層へ集約
    comments.forEach(function (art) {
      var pid = art.dataset.parentId;
      if (!pid) return;
      var parent = map[pid];
      if (!parent || parent === art) return;
      var root = rootOf(art);
      if (!root || root === art) return;
      // 返信には常に @相手名（直接の返信先）を付与
      var name = authorName(parent);
      var body = art.querySelector('.comment-body');
      if (name && body && !body.querySelector('.comment-mention')) {
        var mention = document.createElement('span');
        mention.className = 'comment-mention';
        mention.textContent = '@' + name + ' ';
        body.insertBefore(mention, body.firstChild);
      }
      // 親直下の返信を折りたたみアコーディオンに集約
      var details = root.querySelector(':scope > .comment-replies-accordion');
      if (!details) {
        details = document.createElement('details');
        details.className = 'comment-replies-accordion';
        var summary = document.createElement('summary');
        summary.className = 'comment-replies-summary';
        details.appendChild(summary);
        var newBox = document.createElement('div');
        newBox.className = 'comment-replies';
        details.appendChild(newBox);
        root.appendChild(details);
      }
      var box = details.querySelector(':scope > .comment-replies');
      box.appendChild(art);
    });
    // ネスト内を投稿時刻の昇順（古い→新しい＝最新が下）に並べ替え
    Array.prototype.forEach.call(
      list.querySelectorAll('.comment-replies'),
      function (box) {
        Array.prototype.slice
          .call(box.children)
          .sort(function (a, b) {
            return (parseInt(a.dataset.created, 10) || 0) - (parseInt(b.dataset.created, 10) || 0);
          })
          .forEach(function (item) {
            box.appendChild(item);
          });
      }
    );
    // 各アコーディオンの summary に返信件数を表示
    var showRepliesTpl = cfg.showReplies || '';
    Array.prototype.forEach.call(
      list.querySelectorAll('.comment-replies-accordion'),
      function (details) {
        var box = details.querySelector(':scope > .comment-replies');
        var summary = details.querySelector(':scope > .comment-replies-summary');
        var n = box ? box.children.length : 0;
        if (summary) summary.textContent = showRepliesTpl.replace('%count%', n);
      }
    );

    // 親コメントを初期5件のみ表示し、「もっと読む」で10件ずつ展開
    var INITIAL_COUNT = 5;
    var STEP_COUNT = 10;
    var topComments = Array.prototype.filter.call(
      list.children,
      function (el) {
        return el.classList && el.classList.contains('article-template__comments-comment');
      }
    );
    if (topComments.length > INITIAL_COUNT) {
      var shownCount = INITIAL_COUNT;
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'comment-load-more button button--secondary';
      moreBtn.textContent = cfg.loadMore || '';
      list.insertAdjacentElement('afterend', moreBtn);
      var renderTopComments = function () {
        topComments.forEach(function (el, i) {
          el.hidden = i >= shownCount;
        });
        moreBtn.hidden = shownCount >= topComments.length;
      };
      moreBtn.addEventListener('click', function () {
        shownCount += STEP_COUNT;
        renderTopComments();
      });
      renderTopComments();
    }
  }

  // 返信フォーム連携
  var bodyField = document.getElementById('CommentForm-body');
  var form = bodyField ? bodyField.form : null;
  var accordion = document.querySelector('.comment-form-accordion');
  var chip = document.getElementById('comment-reply-chip');
  var chipText = document.getElementById('comment-reply-chip-text');
  var cancelBtn = document.getElementById('comment-reply-cancel');
  var replyingToTpl = cfg.replyingTo || '';
  var replyTo = null;

  function clearReply() {
    replyTo = null;
    if (chip) chip.hidden = true;
  }
  function setReply(id, author) {
    replyTo = id;
    // まずアコーディオンを確実に開く（閉じていると本文欄が操作できないため）
    if (accordion && !accordion.open) accordion.open = true;
    if (chip && chipText) {
      chipText.textContent = replyingToTpl.replace('%name%', author);
      chip.hidden = false;
    }
    // フォーカス・スクロールは開閉アニメーションと競合しないよう次フレームへ
    requestAnimationFrame(function () {
      if (bodyField) bodyField.focus();
      if (accordion && accordion.scrollIntoView) {
        accordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  Array.prototype.forEach.call(
    document.querySelectorAll('.comment-reply-btn'),
    function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-reply-id');
        var art = document.querySelector('[data-comment-id="' + id + '"]');
        var nameEl = art ? art.querySelector('.comment-author-name') : null;
        var label = nameEl ? nameEl.textContent.trim() : '';
        setReply(id, label);
      });
    }
  );
  if (cancelBtn) cancelBtn.addEventListener('click', clearReply);
  if (form && bodyField) {
    form.addEventListener('submit', function () {
      if (!replyTo) return;
      // 表示用textareaには触れず、送信用の隠しフィールドにトークン付き本文を入れる
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'comment[body]';
      hidden.value = '[[reply:' + replyTo + ']] ' + bodyField.value;
      form.appendChild(hidden);
      // textareaは送信対象から外す（同名フィールドの二重送信を防ぐ）
      bodyField.removeAttribute('name');
    });
  }

  // 名前入力と投稿者IDを合成して comment[author] に格納
  var nameEl = document.getElementById('CommentForm-name');
  var authorEl = document.getElementById('CommentForm-author');
  if (nameEl && authorEl) {
    var memberId = cfg.memberId;
    var idLabel = cfg.memberIdLabel || '';
    var syncAuthor = function () {
      var n = nameEl.value.replace(/\s+/g, ' ').trim();
      authorEl.value = n ? n + '（' + idLabel + ':' + memberId + '）' : idLabel + ':' + memberId;
    };
    nameEl.addEventListener('input', syncAuthor);
    syncAuthor();
  }
})();
